/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { KTSVG } from '../../../../../_metronic/helpers'
import { searchSubstitut } from '../../../../utils/search';
import { SearchInput } from '../../../components/SearchInput';
//import { ModalCreateCredential } from '../../../portals/components/modalCreateCredential';
import { ModalAddUpdateClient } from '../ModalAddEditClient';
import { ModalDeleteClient } from '../ModalDeleteClient';
import { ModalDetailsClient } from '../ModalDetailsClient';
import { ModalAddUpdateUser } from '../../../users/components/ModalAddEditUser';
import { TableBody } from './TableBody';
import { ModalAddClientPlanilha } from '../ModalAddClientPlanilha';
import { PaginationGlobal } from '../../../components/PaginationGlobal';
import { SearchInputV3 } from '../../../components/SearchInputV3';
import { SelectGlobal } from '../../../components/SelectGlobal';
import { Loading } from '../../../components/Loadings/loading';
import listLayoutStyles from '../../../components/ListTableLayout/listTableLayout.module.css';


type Props = {
  className: string;
  clients: any[]
  refresh: any
  pagination: any,
  setPagination: any,
  setFilterName: any;
  loading: boolean;
  qtd: any
  plants?: any[]
  users?: any[]
  tags?: any[]
  filterLinkedUser?: string
  setFilterLinkedUser?: any
  filterUserId?: string
  setFilterUserId?: any
  filterHasPlant?: string
  setFilterHasPlant?: any
  filterPlantId?: string
  setFilterPlantId?: any
  filterTag?: string
  setFilterTag?: any
}

const TableClients: React.FC<Props> = ({
  className,
  clients,
  refresh,
  pagination,
  setPagination,
  setFilterName,
  loading,
  qtd,
  plants = [],
  users = [],
  tags = [],
  filterLinkedUser = "",
  setFilterLinkedUser,
  filterUserId = "",
  setFilterUserId,
  filterHasPlant = "",
  setFilterHasPlant,
  filterPlantId = "",
  setFilterPlantId,
  filterTag = "",
  setFilterTag,

}) => {
  
  const [mySearch, setMySearch] = useState<any[]>([]);
  const [control, setControl] = useState(false);
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [showCreateAppModalPlanilha, setShowCreateAppModalPlanilha] = useState<boolean>(false)
  const [showCreateAppModalDelete, setShowCreateAppModalDelete] = useState<boolean>(false)
  const [showCreateAppModalDetails, setShowCreateAppModalDetails] = useState<boolean>(false)
  const [myClient, setMyClient] = useState<any | null>(null);
  const [editingUser, setEditingUser] = useState<any | null>(null);

  useEffect(()=> {
    const search_clients = mySearch.length > 0 ? 
    searchSubstitut(clients, mySearch)
      : []
    setMySearch(search_clients)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients])
  
  return (
    <div className={`card ${className} ${listLayoutStyles.listCard}`}>
      
      <div className={`border-0 ${listLayoutStyles.listCardHeader}`} style={{padding: '1.25rem 1.25rem 0'}}>
        <div className={`${listLayoutStyles.listToolbar} ${listLayoutStyles.listToolbarPanel}`}>
          <div className={listLayoutStyles.listToolbarFilters}>
            <SearchInputV3
              className={`form-control form-control-sm ${listLayoutStyles.listSearch}`}
              placeholder='Buscar cliente por nome'
              setMySearch={setFilterName}
              setPagination={setPagination}
              style={{width: '100%'}}
            />

            <div className="dropdown">
              <button
                type="button"
                className="btn btn-lg btn-light btn-active-color-primary btn-sm dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                data-bs-auto-close="outside"
              >
                <span><KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-3'/></span>
              </button>

              <div className={`dropdown-menu dropdown-menu-end p-4 ${listLayoutStyles.listFilterDropdownMenu}`}>
                <label className='form-label fw-bold' style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}>Usinas</label>
                <div className='separator my-2'></div>

                <div style={{marginTop: '0.5rem', marginBottom: '1rem', width: '100%'}}>
                  <SelectGlobal
                    itens={[
                      {name: 'Com usina', value: 'true', linkIcon: '/media/icons/duotune/general/gen043.svg', iconColor: 'success'},
                      {name: 'Sem usina', value: 'false', linkIcon: '/media/icons/duotune/general/gen040.svg', iconColor: 'danger'},
                    ]}
                    buttonAll={true}
                    textSearch={"Buscar"}
                    textButtonInit={"Com usina / Sem usina"}
                    labelKey='name'
                    valueKey='value'
                    typeIcon='img'
                    linkIcon='https://res.cloudinary.com/deq3ehxe3/image/upload/v1735238752/plant2_tuwshh.png'
                    sizeIconSvg='2'
                    value={filterHasPlant}
                    setPagination={setPagination}
                    onChange={(value: string) => {
                      setFilterHasPlant && setFilterHasPlant(value)
                      if (value === '') setFilterPlantId && setFilterPlantId('')
                    }}
                  />

                  <SelectGlobal
                    itens={plants}
                    buttonAll={true}
                    textSearch={"Buscar usina"}
                    textButtonInit={"Filtrar por USINA"}
                    labelKey='name'
                    valueKey='id'
                    typeIcon='img'
                    linkIcon='https://res.cloudinary.com/deq3ehxe3/image/upload/v1735238752/plant2_tuwshh.png'
                    sizeIconSvg='2'
                    value={filterPlantId}
                    className='mt-1'
                    setPagination={setPagination}
                    onChange={(value: string) => {
                      setFilterPlantId && setFilterPlantId(value)
                    }}
                  />

                  <SelectGlobal
                    itens={tags}
                    buttonAll={true}
                    textSearch={"Buscar tag"}
                    textButtonInit={"Filtrar por TAG"}
                    labelKey='name'
                    valueKey='id'
                    typeIcon='tag'
                    colorKey='color'
                    linkIcon='/media/icons/duotune/general/gen025.svg'
                    sizeIconSvg='2'
                    value={filterTag}
                    className='mt-1'
                    setPagination={setPagination}
                    onChange={(value: string) => {
                      setFilterTag && setFilterTag(value)
                    }}
                  />

                  <label className='form-label fw-bold' style={{marginTop: '1rem', marginBottom: '0.5rem'}}>Usuarios</label>
                  <div className='separator my-3'></div>

                  <SelectGlobal
                    itens={[
                      {name: 'Com usuário', value: 'true', linkIcon: '/media/icons/duotune/general/gen043.svg', iconColor: 'success'},
                      {name: 'Sem usuário', value: 'false', linkIcon: '/media/icons/duotune/general/gen040.svg', iconColor: 'danger'},
                    ]}
                    buttonAll={true}
                    textSearch={"Buscar"}
                    textButtonInit={"Com usuário / Sem usuário"}
                    labelKey='name'
                    valueKey='value'
                    typeIcon='svg'
                    linkIcon='/media/icons/duotune/communication/com006.svg'
                    sizeIconSvg='2'
                    value={filterLinkedUser}
                    className='mt-1'
                    setPagination={setPagination}
                    onChange={(value: string) => {
                      setFilterLinkedUser && setFilterLinkedUser(value)
                      if (value === '') setFilterUserId && setFilterUserId('')
                    }}
                  />

                  <SelectGlobal
                    itens={users}
                    buttonAll={true}
                    textSearch={"Buscar usuário"}
                    textButtonInit={"Filtrar por USUÁRIO"}
                    labelKey='name'
                    valueKey='id'
                    typeIcon='svg'
                    linkIcon='/media/icons/duotune/communication/com006.svg'
                    sizeIconSvg='2'
                    value={filterUserId}
                    className='mt-1'
                    setPagination={setPagination}
                    onChange={(value: string) => {
                      setFilterUserId && setFilterUserId(value)
                    }}
                  />
                </div>

                <div className='separator my-2'></div>

                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <button
                    className='btn btn-color-gray-600 btn-active-color-primary'
                    onClick={() => {
                      setFilterHasPlant && setFilterHasPlant('')
                      setFilterPlantId && setFilterPlantId('')
                      setFilterTag && setFilterTag('')
                      setFilterLinkedUser && setFilterLinkedUser('')
                      setFilterUserId && setFilterUserId('')
                      setPagination((prev: any) => ({...prev, page: 1}))
                    }}>
                    Limpar todos os filtros <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`card-toolbar ${listLayoutStyles.listToolbarActions}`}
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click para adicionar uma unidade filial'
          >
            <a
              onClick={(event) => {
                event.preventDefault()
                setShowCreateAppModal(true)
              }}
              href='#'
              className='btn btn-sm btn-light-primary me-1'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              Novo Cliente
            </a>

            <a
              onClick={(event) => {
                event.preventDefault()
                setShowCreateAppModalPlanilha(true)
              }}
              href='#'
              className='btn btn-sm btn-light-primary'
            >
              <KTSVG path='/media/icons/duotune/files/fil009.svg' className='svg-icon-2' />
            </a>
          </div>
        </div>
      </div>

      <div className={`card-body py-3 ${listLayoutStyles.listTablePanel}`}>
        <div className={`table-responsive ${listLayoutStyles.listTableWrap}`}>
          <table className='table table-row-dashed table-hover table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bolder text-muted fs-7 text-uppercase gs-0'>
                {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-9-check'
                    />
                  </div>
                </th> */}
                <th className='min-w-250px'>Nome</th>
                <th className='min-w-200px'>CPF</th>
                <th className='min-w-140px'>E-mail</th>
                <th className='min-w-140px'>Usuario Vinculado</th>
                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead>
                {loading ?
                  <div>
                    <Loading myClass={`spinner-border`}/>
                  </div>
                :
                <TableBody 
                  clients={clients} 
                  setMyClient={setMyClient}
                  setShowCreateAppModal={setShowCreateAppModal}
                  setShowCreateAppModalDelete={setShowCreateAppModalDelete}
                  setShowCreateAppModalDetails={setShowCreateAppModalDetails}
                  onEditUser={(client: any) => {
                    if (!client?.user) return
                    // mesmo formato que a listagem de usuários envia ao modal de edição
                    setEditingUser({
                      ...client.user,
                      role: client.user.role?.slug || 'CLIENTE',
                      idClient: client.id,
                      idUnitBranch: client.unitBranchs?.[0]?.id || null,
                      idCompany: null,
                    })
                  }}
                />}
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
      </div>

      <div className={`card-footer pt-1 ${listLayoutStyles.listCardFooter}`}>
        {/* o footer compartilhado zera o padding-bottom; o respiro fica aqui para não colar no fundo do card */}
        <div style={{paddingBottom: '1.25rem'}}>
          <PaginationGlobal
              pagination={pagination}
              setPagination={setPagination}
              qtd={qtd}
          />
        </div>
      </div>

        <ModalAddUpdateUser
          show={!!editingUser}
          id={editingUser ? editingUser.id : undefined}
          data={editingUser ? editingUser : undefined}
          handleClose={() => {
            setEditingUser(null)
            refresh()
          }}
        />

        <ModalAddClientPlanilha
          show={showCreateAppModalPlanilha}
          //data={myClient ? myClient : undefined}
          handleClose={() => {
            setMyClient(null)
            setShowCreateAppModalPlanilha(false)
            refresh()
          }} 
        />

        <ModalAddUpdateClient
          show={showCreateAppModal}
          id={myClient ? myClient.id : undefined} 
          data={myClient ? myClient : undefined}
          handleClose={() => {
            setMyClient(null)
            setShowCreateAppModal(false)
            refresh()
          }} 
        />
        <ModalDeleteClient 
          show={showCreateAppModalDelete}
          data={myClient}
          id={myClient ? myClient.id : undefined} 
          handleClose={() => {
            setMyClient(null)
            setShowCreateAppModalDelete(false)
            refresh()
          }} 
        />

        <ModalDetailsClient
          show={showCreateAppModalDetails}
          id={myClient ? myClient.id : undefined} 
          handleClose={() => {
            setMyClient(null)
            setShowCreateAppModalDetails(false)
            refresh()
          }} 
        />
      {/* begin::Body */}
    </div>
  )
}

export {TableClients}
